<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             top='10vh' @close='dialogClose' width='1050px' append-to-body>
    <el-form v-loading='formLoading' :model='form' label-width='140px' label-position='right'
             ref='ruleForm' class='p10 formHeight infoForm'>
      <div-border label='基础信息' class='p20'>
        <el-row :gutter='10'>
          <el-col :span='12'>
            <el-form-item label='KPI考核指标：'>
              <span>{{ form.examineTarget |examineTargetFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='分值：'>
              <span>{{ form.score |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='计算公式：'>
              <span>{{ form.calculationFormula |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='目标值：'>
              <span>{{ form.targetValue |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='数据提供部门：'>
              <span>{{ form.provideDepartment |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='考核周期：'>
              <span>{{ form.examineDate |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='考核部门：'>
              <span>{{ form.examineDepartment |valFormat }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>
      <div-border label='评分标准' class='p20' v-if='form.examineTarget === "0"'>
        <el-table
          ref='searchTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          sizi='mini'
          max-height='200'
          :header-cell-style='headerCellStyle'>
          <el-table-column label='序号' type='index' align='center' />
          <el-table-column label='评分标准' prop='scoringCriteriaStr' align='center' />
          <el-table-column label='分值' prop='score' align='center' />
        </el-table>
      </div-border>

      <div-border label='操作记录' class='p20'>
        <el-table
          ref='registerTable'
          row-key='id'
          :data='form.operateRecordList'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
          <el-table-column prop='operateType' label='操作类型' align='center' />
          <el-table-column prop='operationName' label='操作人' align='center' />
          <el-table-column prop='remark' label='备注' align='center' />
        </el-table>
      </div-border>
    </el-form>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { portWarehouseCostDetail } from '@/service/warehouse';
  import { receiptDetails, receiptFormSearch } from '@/service/receipt';
  import { indicatorSettingsGrading } from '@/service/supplierAssessment';

  export default {
    name: 'indicatorManagementInfo',
    components: { divBorder },
    data() {
      return {
        dialogTitle: '详情',
        dialogVisible: false,
        defaultForm: {},
        form: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        formLoading: false,
      };
    },
    filters: {
      valFormat(str) {
        if (str) {
          return str;
        } else {
          return '无';
        }
      },
      examineTargetFormat(str) {
        switch (str) {
          case '0':
            return 'KPI指标';
          case '1':
            return '物流综合服务能力';
        }
      },
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      // 获取表格数据
      async getTableData(id) {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await indicatorSettingsGrading(id);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data;
      },
      dialogOpen(row) {
        this.form = JSON.parse(JSON.stringify(row));
        this.getTableData(row.id);
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang='scss' scoped></style>
